module.exports = __webpack_public_path__ + "img/scc-02-flat.9b866bbb.png";